<script>
  import { createEventDispatcher } from 'svelte';
  import { goto } from '$app/navigation';
  import { inview } from 'svelte-inview';

  import UserAjax from '@ajax/user';
  import BrowserUtils from '@utils/browser-utils';

  import Avatar from '@components/Avatar.svelte';

  import UserFollowButton from '@app-components/UserFollowButton.svelte';
  import SuggestedFollowers from '@app-components/suggested_followers/SuggestedFollowers.svelte';
  import DisplayName from '@components/DisplayName.svelte';
  import Username from '@components/Username.svelte';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let profileUser;
  export let currentUser;
  export let context = 'following';

  let eventContext = context == 'following' ? 'other_profile_following_dialog' : 'other_profile_followers_dialog';

  if (currentUser == profileUser) {
    eventContext = context == 'following' ? 'my_profile_following_dialog' : 'my_profile_followers_dialog';
  }

  let loading = true;
  let oldUsers = [];
  let users = [];
  let page = 1;
  let hasMore = false;
  let totalCount = null;

  $: showSuggestedFollowers =
    currentUser && currentUser.id && context == 'following' && currentUser.id == profileUser.id;

  let getMoreContent = function () {
    page = page + 1;
    oldUsers = oldUsers.concat(users);
    users = [];
    loading = true;
    getContent();
  };

  let getContent = async function () {
    let response =
      context == 'following'
        ? await UserAjax.following(profileUser, page)
        : await UserAjax.followers(profileUser, page);
    users = response['users'];
    hasMore = response['has_more'];
    if (totalCount === null) {
      totalCount = response['count'];
    }
    loading = false;
  };

  let afterUnfollow = function (user) {
    if (oldUsers && context == 'following' && profileUser.id == currentUser.id) {
      oldUsers = oldUsers.filter((x) => x.id != user.id);
    }
  };
  getContent();
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .user-list {
    list-style: none;
    height: 508px;
    padding: 10px 40px 30px 54px;
    overflow: auto;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .empty-list {
    margin-top: 25px;
    @include typeface-h5($font-weight-regular);
    text-align: center;
    font-size: 20px;
    line-height: 30px;
    overflow: hidden;

    .link {
      cursor: pointer;
      color: $purple-50;
      &:hover {
        color: $purple-60;
      }
    }
  }

  .user-list:after {
    content: '';
    display: block;
    height: 25px;
    width: 100%;
  }

  .flex-item {
    display: flex;
  }

  .left-side {
    cursor: pointer;

    &:hover {
      .name {
        color: $dark-blue;
      }
    }
  }

  .user-row {
    justify-content: space-between;
    align-items: center;
    height: 40px;
  }

  .user-row + .user-row {
    margin-top: 24px;
  }

  .user-info {
    flex-direction: column;
    margin-left: 15px;
    vertical-align: middle;
    justify-content: center;
    margin-right: 30px;
  }

  .modal-follow-button {
    width: 115px;
    flex-shrink: 0;
    margin-top: -5px;
  }

  .header {
    text-align: center;
  }
  .modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 45px;
  }

  .modal__title {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 0;
    color: black;
    box-sizing: border-box;
  }

  .modal__close {
    color: $neutral-gray;
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
    font-size: 16px;
    position: absolute;
    right: 18px;

    &:hover {
      font-weight: bold;
    }
  }

  .modal__header .modal__close:before {
    content: '\2715';
  }

  .modal__close_ios:before {
    font-size: 22px;
  }

  .mobile {
    .user-list {
      height: calc(100vh - 75px);
      padding: 10px 30px 10px 30px;
    }
    .modal__title {
      @include typeface-mobile-menu-header(bold);
    }

    .modal__header {
      margin-bottom: 32px;
    }

    .modal__close {
      position: absolute;
      top: 6px;
      right: 14px;
      font-size: 20px;
    }

    .user-info {
      margin-right: 5px;
    }
  }
</style>

<div class:mobile={mobile}>
  <header class="modal__header">
    <h3 class="modal__title header">
      {#if totalCount}
        {totalCount} {context == 'following' ? 'Following' : `Follower${totalCount != 1 ? 's' : ''}`}
      {/if}
    </h3>
    {#if true}
      <button
        class="modal__close {BrowserUtils.isIOS() ? 'modal__close_ios' : ''} {$$props.closeButtonClass}"
        style={$$props.closeButtonStyle}
        on:click={() => {
          dispatch('close');
        }} />
    {/if}
  </header>
  <div>
    {#if totalCount == 0}
      <div class="user-list empty-list">
        {#if context == 'following'}
          <p>
            Check out the <span class="link" on:click={() => goto('/discover')}>Discover</span> page to find interesting
            <br /> Benable creators to follow!
          </p>
          {#if showSuggestedFollowers}
            <div style="margin-top: 100px;">
              <SuggestedFollowers
                view="followings"
                mobile={mobile}
                currentUser={currentUser}
                maxShown={2}
                page="follow-modal" />
            </div>
          {/if}
        {:else}
          <p>
            When you invite people to join Benable using <br /> your
            <span class="link" on:click={() => goto('/app_invites')}>Invite Code</span>, they’ll follow you
            automatically!
          </p>
        {/if}
      </div>
    {:else}
      <ul class="user-list purple-scrollbar">
        {#each oldUsers as user, idx}
          <li class="user-row flex-item">
            <a
              on:click={() => window.open(user.profile_path, mobile ? '_self' : '_blank')}
              class="flex-item left-side"
              href={user.profile_path}
              target={mobile ? '_self' : '_blank'}>
              <Avatar src={user.avatar_url} width={40} user={user} mobile={mobile} />
              <div class="flex-item user-info">
                <DisplayName user={user} mobile={mobile} />
                <Username user={user} mobile={mobile} />
              </div>
            </a>
            <div class="modal-follow-button flex-item">
              {#if user.id != currentUser.id && currentUser.demo_user != true}
                <UserFollowButton
                  user={user}
                  mobile={mobile}
                  profileUser={profileUser}
                  afterUnfollow={afterUnfollow}
                  size={'small-plus'}
                  context={eventContext} />
              {/if}
            </div>
          </li>
          {#if showSuggestedFollowers && oldUsers.length > 0 && idx == 3}
            <div>
              <SuggestedFollowers view="followings" currentUser={currentUser} maxShown={2} page="follow-modal" />
            </div>
          {/if}
        {/each}
        {#if loading}
          <li>
            <div
              style="text-align: center; opacity: 0.7; color: #1a1a1a; margin-bottom: 50px; min-height: 200px; margin-top: px">
              <i class="fa fa-spin fa-spinner" />
              <span style="margin-left: 8px;">Loading</span>
            </div>
          </li>
        {/if}
        {#each users as user, index}
          <li class="user-row flex-item">
            <a
              on:click={() => window.open(user.profile_path, mobile ? '_self' : '_blank')}
              class="flex-item left-side"
              href={user.profile_path}
              target={mobile ? '_self' : '_blank'}>
              <Avatar src={user.avatar_url} width={40} user={user} mobile={mobile} />
              <div class="flex-item user-info">
                <DisplayName user={user} mobile={mobile} />
                <Username user={user} mobile={mobile} />
              </div>
            </a>
            <div class="modal-follow-button flex-item">
              {#if user.id != currentUser.id && currentUser.demo_user != true}
                <UserFollowButton
                  user={user}
                  profileUser={profileUser}
                  afterUnfollow={afterUnfollow}
                  size={'small-plus'}
                  context={eventContext} />
              {/if}
            </div>
          </li>
          {#if showSuggestedFollowers && oldUsers.length == 0 && (index == 3 || (users.length < 4 && users.length - 1 == index))}
            <div>
              <SuggestedFollowers
                view="followings"
                mobile={mobile}
                currentUser={currentUser}
                maxShown={2}
                page="follow-modal" />
            </div>
          {/if}
          {#if hasMore && users.length - 50 == index}
            <li>
              <div id="something" use:inview={{}} on:enter={getMoreContent} />
            </li>
          {/if}
        {/each}
      </ul>
    {/if}
  </div>
</div>
